import { languageIndex } from "@utils";
export const fields = (language) => {
    const index = languageIndex(language);
    return {
        itemPlaceholder: ["Text", "Текст"][index],
        addLabel: ["Add Item", "Добавить Элемент"][index],
    };
};
